import type { CertVerdict } from "./schemas";

export type CertChipTone = "ok" | "warn" | "muted";
export type CertChipView = { text: string; tone: CertChipTone };

/** "2027-10-06" → "06/10"; chuỗi lạ trả nguyên, không đoán. */
export function formatDdMm(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  return m ? `${m[3]}/${m[2]}` : iso;
}

/** Chip trạng thái chứng chỉ (spec §7.1). null = dòng không kiểm → không hiện gì. */
export function certChip(v: CertVerdict | null | undefined): CertChipView | null {
  if (!v || !v.required) return null;
  const tier = v.tier ? `G${v.tier} · ` : "";
  switch (v.status) {
    case "valid":
      return { text: `${tier}${v.label}`, tone: "ok" };
    case "grace":
      return { text: `Ân hạn tới ${formatDdMm(v.graceUntil ?? "")} · ${v.label}`, tone: "warn" };
    case "expired":
      return { text: `Hết hạn ${v.label}`, tone: "muted" };
    case "revoked":
      return { text: `Đã thu hồi ${v.label}`, tone: "muted" };
    default:
      return { text: `Chưa có chứng chỉ ${v.label}`, tone: "muted" };
  }
}

/** Câu nhắc khi gán người thiếu chứng chỉ ở chế độ NHẮC (xác nhận rồi mới gán). */
export function certWarnText(name: string, v: CertVerdict): string {
  return `${name} chưa có chứng chỉ ${v.label} còn hiệu lực — vẫn gán? (sẽ được ghi nhận là gán tạm)`;
}
